import AbstractComponent from './AbstractComponent';
import Logger from '../utils/Logger';
import { getPageWidth } from '../utils/JsUtils';
import { css, hasClass } from '../utils/CssUtils';
import { addEventListener } from '../utils/EventUtils';
import { catchPromiseException } from '../utils/JsUtils';

export default class ContentCard extends AbstractComponent {
    constructor(...args) {
        Logger.log('ContentCard->constructor()');
        super(...args);

        this.classname = 'c-content-card';
        this.isVideo = false;
        this.initDomElements();
        this.addEventListeners();
    }

    initDomElements() {
        this.isVideo = hasClass(this.$el, this.getClassname('--video'));
        this.$mediaCoverVideo = this.$el.querySelector(this.getSelector('__media-cover__video'));
        this.$video = this.$el.querySelector(this.getSelector('__media-cover__video .c-media-cover__media'));
    }

    addEventListeners() {
        if (this.isVideo && this.$mediaCoverVideo && this.$video) {
            this.boundMouseEnterEventListener = this.mouseEnterEventListener.bind(this);
            addEventListener(this.$el, 'mouseenter', this.boundMouseEnterEventListener);
            addEventListener(this.$el, 'touchstart', this.boundMouseEnterEventListener);

            this.boundMouseLeaveEventListener = this.mouseLeaveEventListener.bind(this);
            addEventListener(this.$el, 'mouseleave', this.boundMouseLeaveEventListener);
            addEventListener(this.$el, 'touchend', this.boundMouseLeaveEventListener);
        }
    }

    mouseEnterEventListener() {
        if (!this.isVideo || !this.$mediaCoverVideo || !this.$video) { return; }
        css(this.$mediaCoverVideo, { opacity: 1 });
        catchPromiseException(this.$video.play());
    }

    mouseLeaveEventListener() {
        if (!this.isVideo || !this.$mediaCoverVideo || !this.$video) { return; }
        catchPromiseException(this.$video.pause());
    }

    destroy() { }
}